import UsersDomainAdminPage from './users-domain-admin';

export default UsersDomainAdminPage;
